export default "__VITE_ASSET__BuwIT3MC__"